import React, { ReactNode, memo } from 'react';

import { ApdexTask } from 'src/types/apdex';

import ApdexMeasuredLink from './apdex-measured-link';

type SourceDirLinkProps = {
  children: ReactNode | null | undefined;
  className?: string;
  onClick?: (event: React.SyntheticEvent<HTMLAnchorElement>) => any;
  qaId?: string;
  href: string;
};

const SourceDirLink: React.FC<SourceDirLinkProps> = props => {
  const { children, href, ...restProps } = props;

  return (
    <ApdexMeasuredLink to={href} task={ApdexTask.Source} {...restProps}>
      {children}
    </ApdexMeasuredLink>
  );
};

export default memo(SourceDirLink);
